import React from "react";
import {RouteComponentProps} from "react-router";
import {IAuthStore, ISignInResult} from "Stores/Auth/types";
import {RouterStore} from "mobx-react-router";
import {inject, observer} from "mobx-react";
import {observable} from "mobx";
import {Login2FAContent, Login2FAButtons, Login2FAText, Login2FAButton} from "@src/Components/Pages/Authorization/Login2FA/styles";
import {Values} from "Tools/Values";
import {Button} from "@material-ui/core";
import OTPInputForm from "@src/Components/Ui/OTPInputForm/OTPInputForm";
import { customDecodeURI } from "../../../../Tools/Helpers/uriEncodingHelper";

interface IProps extends RouteComponentProps {
    auth?: IAuthStore;
    routing?: RouterStore;
}

@inject("auth", "routing")
@observer
export default class Login2FA extends React.Component<IProps> {
    @observable otpCode: string = '';
    @observable isValid: boolean = true;
    @observable returnUrl: string = '';

    handleOtpChange(code: string) {
        this.otpCode = code;
        if (!this.isValid) {
            this.isValid = true;
        }
    }

    redirectToHomePage() {
        this.props.routing.history.push("/");
    }

    redirectUsingReturnUrl() {
        let returnUrl = new URLSearchParams(this.props.location.search).get("returnUrl") ?? "/";
        returnUrl = customDecodeURI(returnUrl);
        window.location.href = returnUrl ?? this.props.auth.redirectAfterLogin;
    }

    async handleSubmit() {
        if (this.otpCode.length !== 6) {
            return;
        }

        const tenantParam = new URLSearchParams(this.props.location.search).get("tenant");
        const response: ISignInResult = await this.props.auth.signInWith2FA(this.otpCode, tenantParam);

        if (response.isUserTwoFactorAuthenticated) {
            this.redirectUsingReturnUrl();
        } else {
            this.isValid = false;
        }
    }

    render() {
        return (
            <Login2FAContent>
                <Login2FAText>
                    {Values.getLocalizationValue('open2faAppToViewCodeLabelContent')}
                </Login2FAText>

                <OTPInputForm
                    value={this.otpCode}
                    onChange={(code: string) => this.handleOtpChange(code)}
                    handleSubmit={this.handleSubmit.bind(this)}
                    error={!this.isValid}
                    autoSubmit={true}
                />

                <Login2FAText>
                    {Values.getLocalizationValue('canSkipStepIfDontNeedAdminAccessLabelContent')}
                </Login2FAText>

                <Login2FAButtons>
                    <Login2FAButton
                        onClick={this.redirectUsingReturnUrl.bind(this)}
                        variant="contained"
                        color="default"
                    >
                        {Values.getLocalizationValue('skip')}
                    </Login2FAButton>

                    <Login2FAButton
                        onClick={this.handleSubmit.bind(this)}
                        isDisabled={this.otpCode.length !== 6}
                        variant="contained"
                        color="primary"
                    >
                        {Values.getLocalizationValue('confirm')}
                    </Login2FAButton>
                </Login2FAButtons>
            </Login2FAContent>
        );
    }
}